import type { TrackedTranslation } from '@ps/web-core-intl';
import { StarsButton } from '@ps/web-shared-components';
import classNames from 'clsx';
import React from 'react';

import type { GameTabsBaseColor } from '@swf/casino';

import styles from './ColoredButton.scss';

interface Props {
  className?: string;
  message: TrackedTranslation;
  active?: boolean;
  baseColor: GameTabsBaseColor;
  onClick?(): void;
}

const ColoredButton: React.FC<Props> = ({ active, baseColor, className, message, onClick }) => (
  <StarsButton
    className={classNames(styles.container, className, styles[baseColor], {
      [styles.active]: active
    })}
    translation={message}
    onClick={onClick}
    size="small"
    track={false}
  />
);

export default ColoredButton;
